<template>
  <div class="container register-container login-container">
    <div class="box" v-loading="loading">
      <div class="logo">
        <img src="@/assets/logo.png" alt="logo" />
      </div>
      <h2 class="title">{{ $t("reset.resetPassward") }}</h2>
      <el-form
        :model="registerForm"
        :rules="rules"
        ref="registerForm"
        v-if="!resetPassword.pwdResetCode"
      >
        <el-form-item prop="email">
          <el-input
            v-model="registerForm.email"
            :placeholder="$t('reset.emailRequired')"
            prefix-icon="el-icon-user"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="verCode">
          <div class="verify-code">
            <el-input
              v-model="registerForm.verCode"
              :placeholder="$t('reset.codeRequired')"
              prefix-icon="el-icon-message"
            >
            </el-input>
            <a
              class="code-btn"
              @click="handleGetVerifyCode"
              v-if="!countdown"
              >{{ $t("reset.getCode") }}</a
            >
            <span class="code-btn disable-btn" v-else>{{ countdown }}</span>
          </div>
        </el-form-item>
        <el-button type="primary" class="submit-btn" @click="next">{{
          $t("reset.next")
        }}</el-button>
        <el-button class="submit-btn" @click="backPage">{{
          $t("reset.goBack")
        }}</el-button>
      </el-form>

      <el-form
        :model="resetPassword"
        :rules="resetPasswordFormRule"
        ref="resetPassword"
        v-else
      >
        <el-form-item prop="login">
          <el-input
            v-model="resetPassword.login"
            prefix-icon="el-icon-user"
            disabled
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="resetPassword.password"
            type="password"
            :placeholder="$t('common.password')"
            prefix-icon="el-icon-lock"
          >
          </el-input>
        </el-form-item>
        <el-button type="primary" class="submit-btn" @click="next">{{
          resetPassword.pwdResetCode
            ? $t("reset.resetPassward")
            : $t("reset.next")
        }}</el-button>
        <el-button class="submit-btn" @click="backPage">{{
          $t("reset.goBack")
        }}</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { register, getPasswordVerifyCode, login, validVerCode, sureResetPassword } from '@/api/user'

export default {
  name: 'UserChangePassword',
  data() {
    return {
      registerForm: {
        email: '',
        verCode: ''
      },
      loading: false,
      countdown: 0,
      rules: {
        email: [
          { required: true, message: this.$t('reset.emailRequired'), trigger: 'blur' },
          { type: 'email', message: this.$t('reset.vaildEamil'), trigger: 'blur' }
        ],
        verCode: [
          { required: true, message: this.$t('reset.verCodeRequired'), trigger: 'blur' }
        ]
      },
      resetPassword: {
        login: null,
        pwdResetCode: null
      },
      resetPasswordFormRule: {
        login: [],
        password: [
          { required: true, message: this.$t('loginPage.passwordRequired'), trigger: 'blur' },
        ]
      }
    }
  },
  created() {
    // 从路由query中获取invitationCode
    const { invitationCode } = this.$route.query;
    if (invitationCode) {
      this.registerForm.invitationCode = invitationCode;
    }
  },
  methods: {
    async next() {
      if (this.resetPassword.pwdResetCode) {
        this.sureReset();
        return;
      }
      const valid = await this.$refs.registerForm.validate();
      if (!valid) {
        return;
      }
      try {
        this.loading = true;
        const res = await validVerCode(this.registerForm);
        this.$set(this.resetPassword, 'login', this.registerForm.email);
        this.$set(this.resetPassword, 'pwdResetCode', res.pwdResetCode);
      } catch (error) {
        console.error('验证失败:', error)
      } finally {
        this.loading = false
      }
    },
    async sureReset() {
      const valid = await this.$refs.resetPassword.validate();
      if (!valid) {
        return;
      }
      try {
        this.loading = true;
        const formObj = JSON.parse(JSON.stringify(this.resetPassword));
        const res = await sureResetPassword(formObj);
        const loginRes = await login({
          name: this.resetPassword.login,
          password: this.resetPassword.password,
          rememberMe: true
        });
        const obj = {
          token: loginRes.token,
          name: this.registerForm.email,
          time: new Date().getTime()
        };
        // 保存token
        localStorage.setItem('_token', JSON.stringify(obj))
        // 跳转到首页或其他页面
        this.$router.push('/hot')
        this.$message.success(this.$t('reset.resetSuccess'))
      } catch (error) {
        this.$message.success(this.$t('reset.resetFailed'));
        console.error('重置密码失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleGetVerifyCode() {
      if (this.countdown > 0) return;
      this.$refs.registerForm.validateField('email', async (valid) => {
        if (valid) {
          // valid为false表示验证未通过
          return;
        }
        // 验证通过
        this.loading = true;
        try {
          await getPasswordVerifyCode(this.registerForm.email);
          this.$message.success(this.$t('reset.verCodeSend'));
          this.countdown = 60;
          this.startCountdown();
        } catch (error) {
          console.error('验证码发送失败:', error);
        } finally {
          this.loading = false;
        }

      });
    },
    startCountdown() {
      const timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(timer)
        }
      }, 1000)
    },
    backPage() {
      if (this.resetPassword.pwdResetCode) {
        this.resetPassword = {};
        return;
      }
      this.$router.back();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/login-common.scss";
.register-container {
  background-image: var(--register-bg-url);
}

.verify-code {
  position: relative;
  .code-btn {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .disable-btn {
    color: #909399;
  }
}

.submit-btn {
  width: 100%;
  margin-top: 20px;
  margin-left: 0 !important;
}

@media screen and (max-width: 768px) {
  .box {
    padding: 20px;
  }
  .logo {
    margin-bottom: 0;
  }
  .logo img {
    height: 100px;
  }
  .title {
    margin-top: 0;
  }
}
</style>